import { ButtonsOptions, TextStyleOptions } from '@df/ui/atomic/atomic-options';
import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { BASIC_COMPONENT_FIELDS, CMS_COMPONENT_CWV_CONFIG } from '../../../../config/component.config';

export default <Omit<NICmsContentComponent.IMeta<NICmsContentComponent.IComponent>, 'type'>>{
    id: 'full-width-banner-v3',
    name: 'Full Width Banner (Variat 3)',
    image: 'assets/images/cms/full-width-banner-v3.png',
    tags: ['Homepage', 'Banner', 'Video'],
    fields: [
        {
            type: NICmsContentField.EFieldType.label,
            key: 'general',
            title: 'General'
        },
        <NICmsContentField.IChoiceField>{
            key: 'reverse',
            type: NICmsContentField.EFieldType.choice,
            title: 'Layout',
            description: 'Position of image',
            default: 'left',
            options: [
                { key: 'left', title: 'Full-size image on left' },
                { key: 'right', title: 'Full-size image on right' }
            ]
        },
        <NICmsContentField.IChoiceField>{
            key: 'padding',
            type: NICmsContentField.EFieldType.choice,
            title: 'Padding',
            required: true,
            default: 'no_padding',
            options: [
                { key: 'with_padding', title: 'Padding' },
                { key: 'no_padding', title: 'No padding' }
            ]
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'link',
            title: 'Link',
            default: '/'
        },
        {
            type: NICmsContentField.EFieldType.label,
            key: 'image-video-section',
            title: 'Image/video'
        },
        {
            type: NICmsContentField.EFieldType.image,
            key: 'image',
            title: 'Image',
            description: 'If both image and video are set then image will be use as a placeholder till video is loaded',
            default: ''
        },
        {
            key: 'video_id',
            type: NICmsContentField.EFieldType.text,
            title: 'ID or URL',
            description: 'Video ID or URL, e.g. https://vimeo.com/442627127'
        },
        {
            type: NICmsContentField.EFieldType.label,
            key: 'section-content',
            title: 'Component content'
        },
        <NICmsContentField.IField>{
            key: 'background_color',
            type: NICmsContentField.EFieldType.colorPicker,
            title: 'Background Color',
            colorPreview: true
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'heading',
            title: 'Heading',
            default: 'dolor sit amet consectetur'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'title',
            title: 'Title',
            default: 'Lorem ipsum'
        },
        <NICmsContentField.IField>{
            key: 'text_color',
            type: NICmsContentField.EFieldType.colorPicker,
            title: 'Text Color',
            colorPreview: true
        },
        <NICmsContentField.IChoiceField>{
            key: 'title_style',
            type: NICmsContentField.EFieldType.choice,
            title: 'Title Style',
            options: TextStyleOptions
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'cta_text',
            title: 'Button Label',
            default: 'Find out more'
        },
        <NICmsContentField.IChoiceField>{
            key: 'cta_style',
            type: NICmsContentField.EFieldType.choice,
            title: 'Button Style',
            options: ButtonsOptions
        },
        ...BASIC_COMPONENT_FIELDS,
        ...CMS_COMPONENT_CWV_CONFIG
    ]
};
